import RoutePermissions from 'shared/features/auth/authorization/constants/route-permissions';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';

type RootPage = {
  firstAuthorizedPage: string | null;
};

const useRootPage = (): RootPage => {
  const { hasRoutePermission } = usePermissionAuthorization();

  const firstAuthorizedPage = Object.keys(RoutePermissions).find((x) => hasRoutePermission(x as never)) ?? null;

  return {
    firstAuthorizedPage,
  };
};

export default useRootPage;
